import _isEmpty from 'lodash/isEmpty';
import _isString from 'lodash/isString';

import Validate from 'libs/validate';

export function isValidColorString(color = '') {
  if (_isEmpty(color)) {
    return false;
  }

  if (!_isString(color)) {
    return false;
  }

  return Validate.isHexColor(color) || Validate.isRgbaColor(color);
}

export function shouldHideColorPicker(value) {
  if (_isEmpty(value)) {
    return false;
  }
  return !isValidColorString(value);
}
